import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import Vue from 'vue';
import { otRuleTaps } from '../enmu';
var $t = Vue.prototype.$t;

// 招聘时段校验
export var timeIntervalRule = [{
  required: true,
  message: $t('221'),
  trigger: ['blur', 'change']
}];

// settings 下的校验规则
var rules = function rules() {
  var _this = this;
  return {
    type_name: [{
      required: true,
      message: $t('1715'),
      trigger: 'blur'
    }],
    allow_apply_time_interval_forward: [{
      required: true,
      message: $t('1716'),
      trigger: 'blur'
    }],
    allow_apply_time_interval_backward: [{
      required: true,
      message: $t('1716'),
      trigger: 'blur'
    }],
    mini_limit: [{
      required: true,
      message: $t('1716'),
      trigger: 'blur'
    }],
    max_limit: [{
      required: true,
      message: $t('1716'),
      trigger: 'blur'
    }],
    increment_step: [{
      required: true,
      message: $t('1716'),
      trigger: 'blur'
    }],
    allow_apply_date_forward: [{
      validator: function validator(rule, value, callback) {
        var ruleKey = rule.field.split('.')[1]; // working_day
        var settings = _this.form.settings[ruleKey];
        // checkbox 选中的情况下判断值是不是为空
        if (settings.is_allow_apply_date_forward && !settings.allow_apply_date_forward) {
          return callback(new Error(_this.$t('1716')));
        }
        callback();
      },
      trigger: 'blur'
    }],
    allow_apply_date_backward: [{
      validator: function validator(rule, value, callback) {
        var ruleKey = rule.field.split('.')[1]; // working_day
        var settings = _this.form.settings[ruleKey];
        // checkbox 选中的情况下判断值是不是为空
        if (settings.is_allow_apply_date_backward && !settings.allow_apply_date_backward) {
          return callback(new Error(_this.$t('1716')));
        }
        callback();
      },
      trigger: 'blur'
    }]
  };
};

// settings 校验规则生成
var formateRules = function formateRules() {
  var result = {};
  var rule = rules.call(this);
  otRuleTaps.forEach(function (item) {
    Object.keys(rule).forEach(function (key) {
      result["settings.".concat(item, ".").concat(key)] = rule[key];
    });
  });
  return result;
};
export default {
  data: function data() {
    return {
      rules: _objectSpread({
        name: [{
          required: true,
          message: $t('1714'),
          trigger: 'blur'
        }],
        selectedFormate: [{
          required: true,
          message: $t('221'),
          trigger: 'change'
        }]
      }, formateRules.call(this))
    };
  }
};